/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S3_HeadingInputs */

const tr_kvkkbasvuru_s3_heading = /** @type {(inputs: Kvkkbasvuru_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Başvuruda Yer Alması Gereken Bilgiler`)
};

const en_kvkkbasvuru_s3_heading = /** @type {(inputs: Kvkkbasvuru_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Information That Must Be Included in the Application`)
};

const de_kvkkbasvuru_s3_heading = /** @type {(inputs: Kvkkbasvuru_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Im Antrag erforderliche Angaben`)
};

const ru_kvkkbasvuru_s3_heading = /** @type {(inputs: Kvkkbasvuru_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Сведения, которые должны содержаться в обращении`)
};

/**
* | output |
* | --- |
* | "3. Information That Must Be Included in the Application" |
*
* @param {Kvkkbasvuru_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s3_heading = /** @type {((inputs?: Kvkkbasvuru_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s3_heading(inputs)
	if (locale === "de") return de_kvkkbasvuru_s3_heading(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s3_heading(inputs)
	return tr_kvkkbasvuru_s3_heading(inputs)
});